import Link from 'antd/lib/typography/Link';
import * as React from 'react';
import Text from 'antd/lib/typography/Text';

const TermsAndConditions: React.FC = () => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Text type="secondary" style={{ maxWidth: 350, fontSize: 12, textAlign: 'center' }}>
                You acknowledge that you&apos;ve read and agree to our <br />
                <Link href="https://runway.team/terms" target="_blank">
                    Terms of Service
                </Link>{' '}
                and{' '}
                <Link href="https://www.runway.team/privacy" target="_blank">
                    Privacy Policy
                </Link>
                .
            </Text>
        </div>
    );
};

export default TermsAndConditions;
